export const ru: Record<string, string> = {
  // ---------- Tabs ----------
  "tabs.dashboard": "Дашборд",
  "tabs.charts": "Графики",
  "tabs.records": "Записи",
  "tabs.shifts": "Смены",
  "tabs.people": "Люди",
  "tabs.settings": "Настройки",
  "tabs.report": "Отчёт",
  "tabs.emergency": "Экстренная",
  "tabs.my_records": "Мои записи",
  "tabs.turbines": "Турбины",
  "tabs.automatika": "Автоматика",
  "tabs.power_analyzer": "Power Analyzer",
  "tabs.scada": "SCADA",
  "tabs.scada_v2": "Автоматика v2",
  "tabs.combined": "Общая",
  "tabs.incidents": "Аварии",
  "incidents.pick": "Событие",
  "incidents.trip": "Отключение",
  "incidents.onset": "Выход за норму",
  "incidents.window": "Окно данных",
  "incidents.kpi_umax": "U макс",
  "incidents.kpi_kwmax": "P макс",
  "incidents.kpi_qmax": "Q макс",
  "incidents.kpi_hz": "f мин–макс",
  "incidents.kpi_oob": "Вне нормы",
  "incidents.kpi_alarms": "Алармов",
  "incidents.sec": "сек",
  "incidents.chart_v": "Линейные напряжения RS / ST / RT",
  "incidents.chart_p": "Мощность и частота",
  "incidents.chart_pos": "Скорость турбины и направляющий аппарат",
  "incidents.kpi_speed": "Скорость макс",
  "incidents.speed_label": "n — скорость турбины, %",
  "incidents.pos_label": "НА — направляющий аппарат, %",
  "incidents.metrics_n": "показателей",
  "incidents.diff_label": "Дифференциальная защита (87H)",
  "incidents.q1_label": "Выключатель Q1 (ячейка H01)",
  "incidents.fired": "сработала в",
  "incidents.pre_label": "Отклонения до отключения",
  "incidents.grp_power": "Мощность",
  "incidents.grp_voltage": "Напряжение",
  "incidents.grp_current": "Ток",
  "incidents.grp_temperature": "Температуры",
  "incidents.grp_pressure": "Давление",
  "incidents.grp_level": "Уровни",
  "incidents.grp_control": "Управление",
  "incidents.grp_counter": "Счётчики",
  "incidents.marker_trip": "отключение",
  "incidents.marker_onset": "выход за норму",
  "incidents.alarms_title": "Журнал алармов (EN + RU)",
  "incidents.col_ru": "Аларм (русский)",
  "incidents.table_title": "Посекундные данные",
  "incidents.table_note": "Все показатели телеметрии. ◆ — секунда отключения; ⚠ жёлтым — отклонения до аварии (значения-предвестники выделены в строке); красным — напряжение выше нормы; оранжевым — разгон турбины; ⬥/▮ — дифзащита/Q1. Таблица прокручивается вбок, колонка времени закреплена.",
  "combined.title": "Общая картина — все данные",
  "combined.max_kw": "Пиковая мощность",
  "combined.total_energy": "Всего выработано",
  "combined.total_run": "Работа (всё)",
  "combined.by_source": "По источникам данных",
  "combined.sharp_title": "Резкие всплески напряжения — топ 5-мин окон",
  "combined.sharp_hint": "5-мин окна по числу резких скачков от секунды к секунде (≥{kv} кВ). Тап → посекундно",
  "combined.prolonged_title": "Продолжительные всплески — топ 5-мин окон",
  "combined.prolonged_hint": "Окна по длине самой длинной непрерывной серии вне коридора {lo}–{hi} кВ (от {s} с). Тап → посекундно",
  "combined.detail_hint": "Окно ±10 с · {sharp} резких секунд · {oob} секунд вне нормы",
  "combined.legend_sharp": "резкие секунды (|Δ|≥1 кВ)",
  "combined.legend_band": "норма",
  "combined.col_time": "Время",
  "combined.sub_overview": "Обзор",
  "combined.sub_vband": "Коридор {lo}–{hi}",
  "vband.period": "Период",
  "vband.all": "Всё время",
  "vband.days": "дн.",
  "vband.hours": "ч",
  "vband.data": "Данные",
  "vband.bucket": "интервал",
  "vband.in_band": "В коридоре",
  "vband.above": "Выше",
  "vband.below": "Ниже",
  "vband.min_unit": "мин",
  "vband.chart_title": "Движение R / S / T в коридоре {lo}–{hi} кВ",
  "vband.chart_hint": "Зелёная зона — норма {lo}–{hi} кВ. Точки другого цвета — выходы за коридор: красные выше {hi} кВ, синие ниже {lo} кВ. Учитываются только минуты под нагрузкой (остановленный агрегат даёт 0 кВ).",
  "vband.by_phase": "По фазам",
  "vband.phase": "Фаза",
  "vband.excursions": "Выходы за коридор",
  "vband.peak": "Пик, кВ",
  "vband.dur": "Длительность",
  "vband.dir": "Направление",
  "vband.exc_hint": "Отсортированы по величине отклонения. 📈 — посекундная телеметрия этого момента.",
  "vband.no_dev": "Выходов за коридор нет",
  "combined.sub_drill": "Разрез",
  "combined.sub_alarms": "Алармы",
  "combined.event_hint": "Момент аларма {at} (±45 с). ◆ — сама секунда события; красные точки — резкие скачки",
  "combined.no_telemetry": "Телеметрии за этот момент нет",
  "combined.unit_stopped": "Агрегат был остановлен в этот момент (напряжение и мощность = 0)",
  "combined.zero_legend": "🟡 Жёлтым — агрегат был остановлен (только нули)",
  "combined.moment": "момент аларма",
  "combined.drill_source": "Источник",
  "alarms.total": "Всего алармов",
  "alarms.active_now": "Активных сейчас",
  "alarms.not_acked": "Неквитированных",
  "alarms.records": "записей",
  "alarms.by_unit": "По агрегатам",
  "alarms.by_category": "По категориям",
  "alarms.period": "Период",
  "alarms.filter_unit": "Агрегат",
  "alarms.all": "Все",
  "alarms.active_only": "Только активные",
  "alarms.leaderboard": "Топ типов алармов",
  "alarms.leaderboard_hint": "Отсортированы по числу срабатываний. Тап → все вхождения этого аларма",
  "alarms.active_short": "актив.",
  "alarms.last": "посл.",
  "alarms.occurrences": "срабатываний",
  "alarms.all_periods": "Все периоды",
  "alarms.of_total": "из {n} всего",
  "alarms.none_with_data": "Нет срабатываний с телеметрией (станция стояла или данных нет)",
  "alarms.cat.TRIP": "Отключение",
  "alarms.cat.VOLTAGE_MISS": "Пропадание напряж.",
  "alarms.cat.COMM_LOST": "Потеря связи",
  "alarms.cat.LUBRICATION": "Смазка",
  "alarms.cat.POWER_SUPPLY": "Питание",
  "alarms.cat.AUTH": "Авторизация",
  "alarms.cat.SYSTEM": "Система",
  "alarms.cat.OTHER": "Прочее",
  "minmax.min": "мин",
  "minmax.max": "макс",
  "alarms.show_telemetry": "Телеметрия",
  "alarms.filter_cat": "Категория",
  "alarms.log_title": "Журнал алармов",
  "alarms.col_unit": "Агрегат",
  "alarms.col_msg": "Сообщение",
  "alarms.load_more": "Показать ещё",
  "tabs.users": "Пользователи",
  "users.title": "Пользователи",
  "users.create_invite": "➕ Создать приглашение",
  "users.invite_hint": "Одноразовая ссылка, действует 7 дней. Отправьте её человеку — он перейдёт и получит доступ только на просмотр.",
  "users.link_label": "Ссылка-приглашение (нажмите, чтобы скопировать):",
  "users.copy": "Копировать",
  "users.copied": "Скопировано",
  "users.none": "Приглашённых пользователей пока нет.",
  "users.col_user": "Пользователь",
  "users.col_status": "Статус",
  "users.col_joined": "Добавлен",
  "users.col_tabs": "Разделы",
  "users.invite_tabs": "Какие разделы увидит пользователь:",
  "users.invite_name": "Имя (чтобы понимать, кто это):",
  "users.name_placeholder": "напр. Иван — смена 2",
  "users.delete": "Удалить",
  "users.delete_confirm": "Удалить {name}? Доступ к чтению пропадёт, бот перестанет его обрабатывать.",
  "users.active": "активен",
  "users.inactive": "выкл",
  "users.deactivate": "Отключить",
  "users.activate": "Включить",

  // ---------- Автоматика (телеметрия SCADA) ----------
  "auto.sub_overview": "Обзор",
  "auto.sub_charts": "Графики",
  "auto.sub_anomalies": "Отклонения",
  "auto.sub_jumps": "Скачки",
  "auto.sub_minmax": "Мин/Макс",
  "auto.oob_n": "{n} отклонений",
  "auto.dev_by_line": "Отклонения по линиям",
  "auto.dev_short": "откл.",
  "auto.dev_day": "Сутки",
  "auto.dev_total": "Всего за период",
  "auto.dev_band": "норма",
  "auto.v_line": "Линейное, кВ",
  "auto.v_phase": "Фазное, кВ",
  "minmax.bucket": "Интервал",
  "minmax.sec": "посекундно",
  "minmax.time": "Время",
  "minmax.hint": "Нажмите на строку, чтобы провалиться (час → 5 мин → минута). Красный — вне {lo}–{hi} кВ.",
  "minmax.hint_leaf": "Поминутные min/max. Красный — вне {lo}–{hi} кВ.",
  "jumps.hint": "Внезапные шаги между соседними замерами (резко вверх/вниз). Найдено: {n}.",
  "jumps.none": "Резких скачков не найдено.",
  "auto.sub_data": "Данные",
  "auto.all": "Всё",
  "auto.last_3d": "Последние 3 дня",
  "auto.last_1d": "Последний день",
  "auto.data_range": "Данные",
  "auto.timeframe": "Таймфрейм",
  "auto.tf_all": "Все данные",
  "auto.tf_7d": "Последние 7 дней",
  "auto.tf_3d": "Последние 3 дня",
  "auto.tf_1d": "Последние 24 часа",
  "auto.tf_12h": "Последние 12 часов",
  "auto.tf_6h": "Последние 6 часов",
  "auto.tf_1h": "Последний час",
  "auto.tf_custom": "Свой период…",
  "auto.hide_zeros": "Скрыть нули",
  "auto.truncated": "показаны топ-500",
  "auto.tap_for_details": "Нажмите — все показатели",
  "auto.snapshot_title": "📸 Состояние в этот момент",
  "auto.resolution": "Разрешение",
  "auto.res_auto": "Авто",
  "auto.res_raw": "Посекундно",
  "auto.reset_zoom": "Сбросить зум",
  "auto.deviations_n": "{n} с отклонением",
  "auto.drill_hint": "Нажмите на любую точку, чтобы приблизить; или потяните нижний ползунок и нажмите «Зум в выделение». Красные точки — там было отклонение.",
  "auto.zoom_to_sel": "Зум в выделение",
  "auto.back": "← Назад",
  "charts.overlay": "Наложить",
  "charts.overlay_none": "нет",
  "charts.right_axis": "правая ось",
  "auto.filter_metric": "Фильтр по показателю",
  "auto.all_metrics": "Все показатели",
  "auto.minutes": "мин",
  "auto.min_short": "мин",
  "auto.bucket": "интервал",
  "auto.kpi_running": "В работе",
  "auto.kpi_peak_power": "Пик мощности",
  "auto.kpi_avg": "сред",
  "auto.kpi_span": "Период",
  "auto.kpi_energy": "Выработка",
  "auto.kwh": "кВт·ч",
  "auto.mwh": "МВт·ч",
  "auto.col_metric": "Показатель",
  "auto.no_anomalies": "Значимых отклонений за период нет.",
  "auto.anomalies_hint": "{n} событий (≥ {floor}% от нормы, за пределами ±2σ в периоды работы).",
  "auto.off_normal": "от нормы",
  "auto.normal": "норма",
  "auto.when": "когда",
  "auto.upload_title": "Загрузить CSV со станции",
  "auto.upload_hint": "Экспорт SCADA (пробел-разделитель, .csv или .gz). Большие файлы — заливайте .gz. Обрабатывается в фоне; данные отдельны от ручных показаний.",
  "auto.uploading": "Загрузка…",
  "auto.upload_started": "Файл принят — идёт фоновая обработка…",
  "auto.upload_done": "Готово — загружено {rows} строк.",
  "auto.upload_error": "Ошибка обработки — проверьте формат файла.",
  "auto.export_xlsx": "📥 Скачать Excel (за период)",
  "auto.export_hint": "Сырые посекундные строки за выбранный период, исходные колонки, один день = один лист.",
  "auto.imports_title": "Загрузки",
  "auto.col_file": "Файл",
  "auto.col_status": "Статус",
  "auto.col_rows": "Строк",
  "auto.col_period": "Период",

  // ---------- Turbines ----------
  "turbines.title": "🏭 Турбины",
  "turbines.empty_for_station": "На вашей станции пока нет турбин. Обратитесь к админу.",
  "turbines.none_for_station": "Турбин нет.",
  "turbines.active": "активна",
  "turbines.inactive": "выключена",
  "turbines.status_running": "запущена",
  "turbines.status_stopped": "остановлена",
  "turbines.status_off": "отключена",
  "turbines.activate": "Активировать",
  "turbines.deactivate": "Деактивировать",
  "turbines.state_running": "Работает",
  "turbines.state_stopped": "Остановлена",
  "turbines.state_off": "Выведена из эксплуатации",
  "turbines.start_btn": "Старт",
  "turbines.start_sub": "Запустить, зафиксировав текущий KV",
  "turbines.start_title": "Запуск {name}",
  "turbines.confirm_start": "Запустить",
  "turbines.stop_btn": "Стоп",
  "turbines.stop_sub": "Остановить с указанием KW, времени и причины",
  "turbines.stop_title": "Остановка {name}",
  "turbines.confirm_stop": "Остановить",
  "turbines.stop_time": "Время остановки",
  "turbines.stop_reason": "Причина",
  "turbines.stop_reason_placeholder": "Почему турбина остановлена?",
  "turbines.recent_events": "История событий",
  "turbines.evt_start": "Старт",
  "turbines.evt_stop": "Стоп",
  "turbines.tab_list": "Турбины",
  "turbines.tab_history": "История",
  "turbines.no_events": "Событий ещё нет.",
  "turbines.fill_btn": "Заполнить отчёт",
  "turbines.fill_sub": "Внести показания по этой турбине",
  "turbines.fill_sub_offline": "Турбина стоит — запись будет оранжевой",

  // ---------- Common ----------
  "common.loading": "Загрузка…",
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.delete": "Удалить",
  "common.edit": "Изменить",
  "common.create": "Создать",
  "common.close": "Закрыть",
  "common.retry": "Повторить",
  "common.back": "Назад",
  "common.add": "Добавить",
  "common.submit": "Отправить",
  "common.no_changes": "Без изменений",
  "common.saved": "Сохранено",
  "common.copied": "Скопировано",
  "common.copy_link": "📋 Скопировать ссылку",
  "common.no_data": "За выбранный период данных нет.",
  "common.empty": "Пока пусто.",
  "common.error_generic": "Что-то пошло не так. Попробуйте ещё раз.",
  "common.no_connection": "Нет соединения с сервером",
  "common.timeout": "Сервер не отвечает — попробуйте ещё раз",

  // ---------- Access / desktop hint ----------
  "access.locked_title": "Доступ закрыт",
  "access.locked_hint": "Открыть приложение могут только зарегистрированные пользователи. Попросите администратора прислать ссылку-приглашение.",
  "desktop_hint.title": "Откройте в Telegram",
  "desktop_hint.body": "Это Telegram Mini App. Откройте бота в Telegram и нажмите 📱 рядом с полем ввода.",

  // ---------- Periods ----------
  "period.today": "Сегодня",
  "period.yest": "Вчера",
  "period.7d": "7 дней",
  "period.30d": "30 дней",
  "period.all": "Всё",

  // ---------- Status / types ----------
  "status.completed": "✅",
  "status.miss_short": "miss",
  "type.plan": "План",
  "type.emergency": "🚨 Emergency",
  "type.missed": "🚫 Missed",
  "type.late": "🟨 Late",
  "type.offline": "🟠 Offline",
  "filter.all": "Все",

  // ---------- Charts ----------
  "charts.title": "📈 Графики",
  "charts.select_chart": "Выбрать график",
  "charts.turbine": "Турбина",
  "charts.period": "Период",
  "charts.kw_kv_label": "Колебания KW и KV",
  "charts.kw_kv_title": "Динамика KW и KV",
  "charts.kw_kv_hint": "Две линии: KW (левая ось) и KV (правая ось). Видно скачки напряжения.",
  "charts.kw_kv_offline_title": "Динамика KW и KV (при остановленной турбине)",
  "charts.kw_kv_offline_hint": "Только записи, внесённые когда турбина была остановлена. KW (оранжевый, левая ось) и KV (фиолетовый, правая ось).",

  "charts.compare_label": "Сравнение турбин (KW)",
  "charts.compare_hint": "Линии мощности обеих турбин на одном графике. Помогает увидеть, насколько равномерно распределена нагрузка и какая турбина простаивает.",

  "charts.timeline_label": "Таймлайн работы/простоя",
  "charts.timeline_hint": "Полосы для каждой турбины по времени: зелёные сегменты — работала, красные — стояла. На один экран ложится весь downtime за период.",
  "charts.timeline_running": "Работает",
  "charts.timeline_stopped": "Остановлена",

  "charts.temperatures_label": "Температуры BT",
  "charts.temperatures_hint": "Температурные датчики BT 371, BT 372, BT 331, BT 332 на одном графике. Резкий рост любой кривой — сигнал перегрева и риск аварии.",

  "charts.frequency_label": "Частота (Frequency Hz)",
  "charts.frequency_hint": "Частота генерации (Hz) с нормативными границами 49.5–50.5. Любое отклонение более чем на 0.5 Hz — проблема в энергосети.",
  "charts.freq_low": "49.5 Hz (нижн.)",
  "charts.freq_high": "50.5 Hz (верх.)",

  "charts.stop_reasons_label": "Причины остановок",
  "charts.stop_reasons_hint": "Распределение причин из формы Stop турбины. Помогает понять, какие проблемы случаются чаще всего и куда направить ресурсы.",
  "charts.stop_reasons_empty": "За период не было остановок турбин.",
  "charts.reason_unknown": "Без указания",

  "charts.kw_histogram_label": "Распределение KW (гистограмма)",
  "charts.kw_histogram_hint": "Сколько раз показания мощности попали в каждый диапазон по 200 KW. Видно, в каком режиме турбина работает чаще всего.",

  "charts.cos_kvar_label": "cos φ и Kvar",
  "charts.cos_kvar_hint": "Коэффициент мощности cos φ (левая ось, 0..1) и реактивная мощность Kvar (правая ось). Падение cos φ = проблемы качества генерации.",

  "charts.pressure_label": "Давления (BP 371, Bar, Pipe pressure)",
  "charts.pressure_hint": "Все давления на одном графике. Резкие скачки указывают на аварийные ситуации в гидравлическом или паровом контуре.",

  "charts.scatter_label": "KW vs KV (scatter)",
  "charts.scatter_hint": "Точечная диаграмма: каждая точка — одно измерение. Видна корреляция между мощностью и напряжением, аномальные точки выделяются.",

  "analysis.title": "Анализ",
  "analysis.no_data": "Данных за период недостаточно для анализа.",
  "analysis.records": "Учтено записей: {n}.",

  "analysis.kv_ok": "Напряжение в норме (KV {min}–{max}, диапазон 17–22).",
  "analysis.kv_out": "Напряжение вне нормы (KV {min}–{max}, ожидается 17–22). Проверьте состояние сети.",
  "analysis.kw_stable": "Мощность стабильна, средняя {avg} KW.",
  "analysis.kw_unstable": "Мощность нестабильна: разброс {cv}% от среднего {avg} KW. Проверьте нагрузку.",

  "analysis.turbine_idle": "{name}: за период данных нет — турбина простаивала.",
  "analysis.turbine_avg": "{name}: средняя мощность {avg} KW.",
  "analysis.compare_balanced": "Нагрузка распределена равномерно между турбинами.",
  "analysis.compare_imbalance": "Дисбаланс нагрузки: {hi} ({hiAvg} KW) значительно выше {lo} ({loAvg} KW).",

  "analysis.timeline_overall": "Время работы суммарно по всем турбинам: {uptime}%. Всего остановок: {stops}.",
  "analysis.timeline_turbine": "{name}: работала {uptime}% времени, простой {downtime}.",

  "analysis.temp_ok": "Температуры в норме, max {max}°C (порог 70°C).",
  "analysis.temp_warn": "Повышенная температура, max {max}°C. Норма до 70°C, критично >85°C — следите за датчиками.",
  "analysis.temp_critical": "Перегрев! Max {max}°C на датчиках: {sensors}. Требуется внимание.",
  "analysis.temp_avg": "Средняя температура: {avg}°C.",

  "analysis.freq_ok": "Частота стабильна: {min}–{max} Hz, в пределах нормы 49.5–50.5.",
  "analysis.freq_bad": "Частота отклонялась от нормы: ниже 49.5 — {low} точек, выше 50.5 — {high} точек (из {total}).",
  "analysis.freq_avg": "Средняя частота: {avg} Hz.",

  "analysis.stop_none": "За период не было остановок турбин — отлично.",
  "analysis.stop_total": "Всего остановок: {n}.",
  "analysis.stop_top": "Самая частая причина: «{name}» ({pct}%).",
  "analysis.stop_dominant": "Доминирует одна причина: «{name}» ({pct}% всех остановок). Стоит разобраться с источником.",
  "analysis.stop_variety": "Разнообразие причин: {n} разных категорий.",

  "analysis.hist_top": "Чаще всего мощность в диапазоне {range} KW ({pct}%).",
  "analysis.hist_low": "{pct}% записей с низкой мощностью — частые недозагрузки.",
  "analysis.hist_normal": "{pct}% работы на нормальной нагрузке.",
  "analysis.hist_avg": "Средняя мощность: {avg} KW.",

  "analysis.cos_ok": "cos φ в норме (среднее {avg}). Высокое качество генерации.",
  "analysis.cos_warn": "cos φ снижен (среднее {avg}). Норма ≥0.95, рекомендуется компенсация реактивной мощности.",
  "analysis.cos_bad": "cos φ низкий (среднее {avg}). Серьёзные потери — недозагрузка или большая реактивная нагрузка.",
  "analysis.kvar_avg": "Kvar: среднее {avg}, диапазон {min}–{max}.",

  "analysis.pressure_field": "{name}: ср. {avg}, диапазон {min}–{max}.",

  "analysis.scatter_few": "Слишком мало точек для анализа корреляции.",
  "analysis.scatter_points": "На графике {n} точек.",
  "analysis.scatter_corr_pos": "Сильная прямая связь KW и KV (r={r}). С ростом мощности растёт и напряжение.",
  "analysis.scatter_corr_neg": "Сильная обратная связь KW и KV (r={r}). С ростом мощности напряжение падает.",
  "analysis.scatter_corr_none": "Явной корреляции между KW и KV нет (r={r}).",

  // ---------- Dashboard ----------
  "dashboard.title": "📊 Дашборд",
  "dashboard.kpi.completed": "Заполнено",
  "dashboard.kpi.completed_sub": "{pct}% от плана",
  "dashboard.kpi.total": "Всего слотов",
  "dashboard.kpi.missed": "🚫 Пропуски",
  "dashboard.kpi.late": "🟨 Опоздания",
  "dashboard.kpi.emergency": "🚨 ЧП",
  "dashboard.kpi.avg_response": "Avg отклик",
  "dashboard.kpi.avg_response_sub": "От уведомления до старта",
  "dashboard.kpi.avg_kw": "Среднее KW",
  "dashboard.kpi.avg_kv": "Среднее KV",
  "dashboard.kpi.min_max_sub": "min / max за период",
  "dashboard.kpi.min": "min",
  "dashboard.kpi.max": "max",
  "dashboard.turbines.downtime": "Простой",
  "dashboard.turbines.last_reading": "Посл. запись",
  "dashboard.turbines.no_downtime": "Без простоев",
  "dashboard.turbines.no_data": "нет данных",
  "dashboard.turbines.just_now": "только что",
  "dashboard.turbines.ago": "назад",
  "dashboard.turbines.unit_d": "д",
  "dashboard.turbines.unit_h": "ч",
  "dashboard.turbines.unit_min": "мин",
  "dashboard.sparkline.title": "Тренд KW за 24 часа",
  "dashboard.sparkline.hint": "Все онлайн-показания мощности по обеим турбинам",
  "dashboard.distribution.title": "Распределение слотов",
  "dashboard.distribution.on_time": "✅ Вовремя",
  "dashboard.distribution.late": "🟨 Опоздания",
  "dashboard.distribution.missed": "🚫 Пропуски",
  "dashboard.distribution.pending": "⏳ В работе",
  "dashboard.distribution.emergency": "🚨 ЧП",
  "dashboard.by_day.title": "Заполнение по дням, %",
  "dashboard.by_day.tooltip": "{pct}% ({completed}/{total})",
  "dashboard.by_day.tooltip_label": "Заполнение",
  "dashboard.by_hour.title": "Заполнение по часам суток",
  "dashboard.by_hour.legend": "🟢 высокая дисциплина · 🟡 средне · 🔴 частые пропуски",
  "dashboard.by_hour.legend_count": "Сколько отчётов было внесено в каждый час суток (за выбранный период).",
  "dashboard.by_hour.no_data": "нет данных",
  "dashboard.users.title": "Рейтинг ответственных",
  "dashboard.users.col_name": "Имя",
  "dashboard.users.col_avg": "Avg отклик",
  "dashboard.users.bar_title": "Среднее время отклика, сек",
  "dashboard.empty": "За выбранный период данных нет. Попробуйте другой период или подождите следующего часового тика.",

  // ---------- Records (admin) ----------
  "records.title": "📋 Записи",
  "records.from": "От",
  "records.to": "До",
  "records.download_xlsx": "📥 Скачать Excel",
  "records.xlsx_per_day": "Каждый день периода — отдельный лист (формат ведомости показаний).",
  "records.custom_preview": "🛠 Кастом превью",
  "records.col_date": "Дата",
  "records.col_turbine": "Турбина",

  "custom_preview.title": "🛠 Кастом превью",
  "custom_preview.period": "Период",
  "custom_preview.turbine": "Турбина",
  "custom_preview.type": "Тип записи",
  "custom_preview.fields": "Выбрано показателей: {n} из {total}",
  "custom_preview.select_all": "Выбрать все",
  "custom_preview.clear": "Очистить",
  "custom_preview.build_btn": "Сформировать таблицу",
  "custom_preview.building": "Формируем…",
  "custom_preview.rows_count": "Всего строк: {n}",
  "custom_preview.sort_hint": "Нажмите для сортировки",
  "records.col_slot": "Слот",
  "records.col_who": "Кто",
  "records.col_type": "Тип",
  "records.col_status": "Статус",
  "records.detail.title": "Запись #{id}",
  "records.detail.slot": "Слот",
  "records.detail.responsible": "Ответственный",
  "records.detail.started": "Начато",
  "records.detail.completed": "Завершено",
  "records.detail.response": "Отклик",
  "records.detail.fill": "Заполнение",
  "records.detail.reason": "Причина",
  "records.detail.seconds": "с",

  // ---------- My records (responsible) ----------
  "my_records.title": "📋 Мои записи",
  "my_records.download_xlsx": "📥 Скачать Excel",

  // ---------- Shifts (admin) ----------
  "shifts.title": "📅 Расписание смен",
  "shifts.choose_user": "Выбрать ответственного",
  "shifts.fill_range": "📐 Заполнить диапазон",
  "shifts.active_count": "Активные смены ({n})",
  "shifts.empty": "Смен нет. Тыкни день в календаре.",
  "shifts.range.title": "📐 Заполнить диапазон",
  "shifts.range.from": "Начало",
  "shifts.range.to": "Конец",
  "shifts.range.invalid": "Конечная дата раньше начальной",
  "shifts.range.added": "Добавлено: {added}, пропущено: {skipped}",
  "shifts.deactivated": "деактивирован",
  "shifts.more_hidden": "…и ещё {n} смен (скрыто)",

  // ---------- People & stations ----------
  "people.title": "👥 Люди и станции",
  "people.stations": "🏭 Станции ({n})",
  "people.add_station": "➕ Добавить станцию",
  "people.station.name": "Название",
  "people.station.city": "Город",
  "people.station.tz": "Timezone (Europe/Kyiv)",
  "people.station.new_title": "Новая станция",
  "people.station.name_placeholder": "Название (например, Энерго-2)",
  "people.station.confirm_delete": "Удалить станцию «{name}»?",
  "people.station.fill_required": "Заполните название и город",
  "people.invite.title": "Новое приглашение",
  "people.invite.placeholder": "ФИО ответственного",
  "people.invite.create": "➕ Создать приглашение",
  "people.invite.created_for": "✅ Приглашение для «{name}»",
  "people.invite.copy_failed": "Не удалось скопировать. Выделите ссылку вручную.",
  "people.list_title": "Ответственные ({n})",
  "people.list_empty": "Пока никого. Создайте приглашение.",
  "people.deactivate": "Деактивировать",
  "people.activate": "Активировать",
  "people.station_label": "Станция:",
  "people.station_none": "— без станции —",

  // ---------- Settings ----------
  "settings.title": "⚙ Настройки",
  "settings.notification_interval": "Интервал уведомлений, мин ({min}–{max})",
  "settings.notification_hint": "Каждые {n} минут операторам будет приходить уведомление в Telegram. Применяется со следующего тика.",
  "settings.range_error": "Допустимое значение: {min}–{max}",
  "settings.language": "Язык",
  "settings.trigger_running": "Запускаю…",
  "settings.trigger_label": "⚡ Триггер: вызвать часовой тик",
  "settings.trigger_success": "✅ Тик запущен. Ответственным на смене сейчас уйдут уведомления.",
  "settings.trigger_failed": "⚠ {error}",

  // ---------- Report (responsible landing) ----------
  "report.title": "📝 Отчёт",
  "report.ready_to_fill": "Готово к заполнению. Нажмите кнопку ниже.",
  "report.no_slot": "⏳ Сейчас нельзя внести показания",
  "report.no_slot_hint": "Турбина остановлена или вы на выходном.",
  "report.day_off": "🌴 Сегодня у вас выходной",
  "report.day_off_hint": "Уведомления приостановлены до конца смены.",
  "report.fill_btn": "Заполнить отчёт",
  "report.fill_btn_offline": "Заполнить (турбина стоит)",
  "report.fill_sub_active": "Плановые показания за текущий час",
  "report.fill_sub_disabled": "Недоступно сейчас",
  "report.fill_sub_day_off": "Недоступно — выходной",
  "report.fill_sub_offline": "Запись будет помечена оранжевым",
  "report.emergency_btn": "Экстренная ситуация",
  "report.emergency_sub": "Внеплановая запись: KW + KV",
  "report.day_off_btn_off": "Выходной",
  "report.day_off_btn_on": "Отменить выходной",
  "report.day_off_sub_off": "Отметить, что сегодня вы не работаете",
  "report.day_off_sub_on": "Возобновить уведомления по смене",
  "report.day_off_confirm_on": "Отметить сегодня как выходной? Уведомления по этой смене больше не придут.",
  "report.day_off_confirm_off": "Снять отметку «Выходной» — уведомления продолжат приходить?",

  // ---------- Report form ----------
  "report_form.title": "📋 Плановый отчёт",
  "report_form.slot_label": "Слот",
  "report_form.placeholder_pair": "X или X/Y",
  "report_form.placeholder_single": "—",
  "report_form.filled_count": "Заполнено {n} из {total}. Можно отправить и частично.",
  "report_form.expand_all": "Развернуть всё",
  "report_form.collapse_all": "Свернуть всё",
  "bool.on": "Вкл",
  "bool.off": "Выкл",
  "report_form.submit": "Отправить",
  "report_form.submit_sub": "Сохранить введённые значения",
  "report_form.submitting": "Отправляем…",
  "report_form.cancel": "Отменить",
  "report_form.cancel_sub": "Данные не сохранятся",
  "report_form.already_completed": "Этот слот уже заполнен.",
  "report_form.no_slot": "Нет открытого слота.",
  "report_form.offline_title": "Турбина остановлена",
  "report_form.offline_hint": "Запись будет сохранена, но помечена оранжевым — будет видно, что показания введены при остановленной турбине.",

  // ---------- Emergency form ----------
  "emergency.title": "🚨 Экстренная ситуация",
  "emergency.intro": "Внеплановая запись. Обязательны KW и причина; остальные показатели — по желанию. После отправки администраторы получат уведомление.",
  "emergency.reason_label": "Причина",
  "emergency.reason_placeholder": "Опишите, что произошло",
  "emergency.reason_required": "Обязательное поле",
  "emergency.submit_sub_ok": "Сохранить и уведомить администраторов",
  "emergency.submit_sub_disabled": "Сначала укажите причину",
  "emergency.show_extras": "Заполнить остальные показатели (опционально)",
  "emergency.hide_extras": "Скрыть остальные показатели",
  "emergency.landing_what": "Что такое «Экстренная ситуация»?",
  "emergency.landing_when": "Эта запись используется ТОЛЬКО при настоящих аварийных и нештатных событиях — поломка, скачок, утечка и т.п.",
  "emergency.landing_warn": "Если просто нужно внести плановые показания — закройте эту вкладку и используйте «📝 Отчёт».",
  "emergency.landing_btn": "Создать экстренную запись",
  // ---------- Files tab ----------
  "tabs.files": "Файлы",
  "files.title": "Последние файлы",
  "files.hint": "Нажмите на файл — «Телеметрия» откроется ровно на его периоде.",
  "files.open": "Открыть анализ",
  "files.rows": "строк",
  "files.uploaded": "загружен",
  "files.all_title": "Все загруженные файлы",
  "files.f_all": "Все",
  "files.new_rows": "новых строк: {n}",
  "files.repeat": "повтор — всё уже было в базе",
  "files.none": "Загруженных файлов пока нет.",
  "files.row_hint": "Нажмите на строку — она откроется в «Телеметрии».",
  "auto.tf_file": "Файл",

  // ---------- Период и отчёт PDF (Автоматика v2) ----------
  "tabs.telemetry": "Телеметрия",
  "telemetry.src_pa": "Счётчик",
  "period.decimal": ",",
  "period.title": "Период",
  "period.quick": "Быстро",
  "period.by_file": "По файлу",
  "period.custom": "Свой период — до секунды",
  "period.from": "с",
  "period.to": "по",
  "period.duration": "Длительность",
  "period.apply": "Применить",
  "period.bad": "Конец раньше начала",
  "period.change": "Изменить период",
  "period.file": "файл",
  "period.tables": "таблицы",
  "period.coverage": "Данные {s}",
  "period.s": "с",
  "period.h": "ч",
  "period.q_all": "Все данные",
  "period.q_7d": "7 дней",
  "period.q_3d": "3 дня",
  "period.q_24h": "24 ч",
  "period.q_12h": "12 ч",
  "period.q_6h": "6 ч",
  "period.q_1h": "1 ч",
  "period.q_lastday": "Последний день с данными",
  "period.dur_s": "{n} с",
  "period.dur_min": "{n} мин",
  "period.dur_h": "{n} ч",
  "period.dur_d": "{n} сут",
  "period.step_sec": "посекундно",
  "period.step_min": "по минутам",
  "period.step_5min": "по 5 минут",
  "period.step_15min": "по 15 минут",
  "period.step_hour": "по часам",
  "period.step_6h": "по 6 часов",
  "period.step_day": "по суткам",
  "report.pdf_title": "Отчёт PDF",
  "report.includes": "Что войдёт",
  "report.metrics": "показателя",
  "report.i1": "Ключевые цифры периода, реактивная энергия: выдано / потреблено",
  "report.i2": "Графики: напряжение, ток, P, Q, частота, cos φ, направляющий аппарат, подшипники и маслостанция",
  "report.i3": "Таблицы: НА → напряжение → ток → cos φ → P и Q → остальное",
  "report.i4": "Все 43 показателя: начало, мин, средн., макс, конец",
  "report.i5": "Отклонения: напряжение вне {lo}–{hi} кВ, частота, остановки и пуски",
  "report.no_analysis": "Только цифры, графики и таблицы — без интерпретаций.",
  "report.send": "Отправить в чат с ботом",
  "report.full": "Таблицы по всем 43 показателям (части 2–3)",
  "report.make": "Сформировать PDF",
  "report.making": "Собираю PDF… обычно 3–10 секунд",
  "report.done": "Готово",
  "report.pages": "стр.",
  "report.rows_step": "{n} строк {step}",
  "report.sent": "Файл отправлен в чат с ботом",
  "report.not_sent": "Не удалось отправить в чат: {err}",
  "report.open": "Открыть в браузере",
  "report.send_now": "Отправить в Telegram",

  // ---------- Главная / События / Отчёты / Управление (шаг 3) ----------
  "tabs.home": "Главная",
  "tabs.events": "События",
  "tabs.reports": "Отчёты",
  "tabs.admin": "Управление",
  "home.title": "ГЭС Паранда",
  "home.peak": "Пиковая мощность",
  "home.energy": "Всего выработано",
  "home.run": "Под нагрузкой",
  "home.coverage": "Какие данные есть",
  "home.open_telemetry": "в телеметрию",
  "home.last_data": "Последние данные",
  "home.alarms": "Алармы",
  "home.unit_day": "работа {run} · макс {kw} кВт",
  "home.events": "Последние события",
  "home.all": "все",
  "home.no_events": "Остановок и провалов напряжения в данных нет.",
  "home.ev_trip": "Отключение G{u} под нагрузкой {kw} кВт",
  "home.ev_stop": "Остановка G{u} ({kw} кВт перед остановкой)",
  "home.ev_dip": "Провал напряжения G{u} до {kv} кВ, {s} с",
  "home.ev_below": "ниже 18 кВ {s} с",
  "home.events_hint": "Найдено по телеметрии: остановки (мощность → 0) и провалы напряжения ниже {kv} кВ под нагрузкой. Нажмите — откроется телеметрия ±45 с.",
  "home.reports": "Последние отчёты",
  "events.sub_incidents": "Разборы",
  "events.sub_spikes": "Всплески",
  "reports.current": "Выбрано в телеметрии",
  "reports.new_pdf": "Новый PDF за период",
  "reports.generated": "Сформированные PDF",
  "reports.none": "Пока ни одного — нажмите «Новый PDF за период».",
  "reports.made": "сформирован",
  "reports.sent": "отправлен в чат",
  "reports.excel": "Excel за выбранный период",
  "admin.sub_data": "Данные",

  // ---------- События: лента и карточка (шаг 4) ----------
  "events.sub_feed": "Лента",
  "events.k_all": "Всё",
  "events.k_trip": "Отключения",
  "events.k_dip": "Провалы напряжения",
  "events.k_stops": "Остановки и пуски",
  "events.k_alarm": "Алармы",
  "events.k_case": "Разборы",
  "events.u_all": "Все",
  "events.none": "Событий по этим условиям нет.",
  "ev.trip": "Отключение G{u} под нагрузкой {kw} кВт",
  "ev.stop": "Остановка G{u} ({kw} кВт перед остановкой)",
  "ev.start": "Пуск G{u}",
  "ev.start_sub": "через минуту {kw} кВт",
  "ev.dip": "Провал напряжения G{u} до {kv} кВ, {s} с",
  "ev.below": "ниже {kv} кВ {s} с",
  "ev.active": "активен",
  "ev.acked": "квитирован",
  "ev.case": "Разбор: отключение {u}, {d} {h}",
  "ev.case_sub": "посекундная таблица и алармы",
  "ev.chart_u": "напряжение RS / ST / RT, кВ (±60 с)",
  "ev.chart_p": "активная мощность, кВт",
  "ev.no_telemetry": "Телеметрии за этот момент нет.",
  "ev.alarms_around": "Алармы ±5 мин",
  "ev.open_case": "Открыть разбор",
  "ev.open_telemetry": "Открыть в телеметрии",

  // ---------- Управление: Нормы и Система (шаг 5) ----------
  "admin.sub_norms": "Нормы",
  "admin.sub_system": "Система",
  "norms.intro": "Пороги, по которым приложение находит события и отмечает отклонения. Одна настройка действует во всех разделах и в PDF.",
  "norms.g_voltage": "Напряжение 20 кВ",
  "norms.g_trips": "Отключения",
  "norms.g_freq": "Частота",
  "norms.g_spikes": "Всплески напряжения",
  "norms.g_history": "История изменений",
  "norms.v_band": "Коридор нормы",
  "norms.v_dip": "Провал напряжения",
  "norms.trip_s": "Отключение или остановка",
  "norms.f_band": "Норма частоты",
  "norms.sharp_kv": "Резкий скачок",
  "norms.prolonged_s": "Затяжной выход из коридора",
  "norms.v_band_val": "{lo}–{hi} кВ",
  "norms.v_dip_val": "ниже {v} кВ",
  "norms.trip_s_val": "быстрее {v} с",
  "norms.f_band_val": "{lo}–{hi} Гц",
  "norms.sharp_kv_val": "от {v} кВ за 1 с",
  "norms.prolonged_s_val": "от {v} с",
  "norms.v_band_sub": "вне коридора под нагрузкой: G1 — {g1} % минут, G2 — {g2} %",
  "norms.v_dip_sub": "{pct} % от 20 кВ, под нагрузкой, дольше 2 с · сейчас провалов: {n}",
  "norms.trip_s_sub": "нагрузка упала до нуля быстрее — отключение, медленнее — плановая остановка · сейчас отключений: {trips}, остановок: {stops}",
  "norms.f_band_sub": "вне нормы под нагрузкой: G1 — {g1} мин, G2 — {g2} мин",
  "norms.sharp_kv_sub": "скачок напряжения между соседними секундами",
  "norms.prolonged_s_sub": "напряжение вне коридора без перерыва",
  "norms.w_band": "Коридор",
  "norms.w_feed": "Лента событий",
  "norms.w_pdf": "PDF",
  "norms.changed": "изменено",
  "norms.default_is": "по умолчанию {v}",
  "norms.history_empty": "Нормы ещё не менялись — действуют значения по умолчанию.",
  "norms.revert": "Вернуть",
  "norms.footer": "После сохранения нормы события пересчитываются заново, примерно за секунду. Готовые PDF не меняются: в каждом указаны нормы, по которым он сделан.",
  "norms.saved": "Сохранено",
  "norms.saved_rebuilt": "Сохранено, события пересчитаны",
  "norms.undo": "Вернуть как было",
  "norms.done_dips": "Провалов теперь: {n}.",
  "norms.done_trips": "Теперь отключений: {trips}, остановок: {stops}.",
  "norms.threshold": "Порог",
  "norms.lower": "Нижняя граница",
  "norms.upper": "Верхняя граница",
  "norms.u_kv": "кВ",
  "norms.u_s": "с",
  "norms.u_hz": "Гц",
  "norms.pct_nominal": "{p} % от 20 кВ",
  "norms.bad_range": "Нижняя граница должна быть меньше верхней.",
  "norms.now": "Сейчас",
  "norms.if_saved": "Если сохранить",
  "norms.counting": "Считаю…",
  "norms.counting_slow": "Считаю по всем секундам, до 10 с…",
  "norms.computed_on": "Посчитано по всем данным G1 и G2.",
  "norms.save": "Сохранить",
  "norms.save_rebuild": "Сохранить и пересчитать события",
  "norms.saving": "Сохраняю…",
  "norms.unchanged": "Без изменений",
  "norms.reset": "Вернуть по умолчанию: {v}",
  "norms.pv_dips": "Провалов",
  "norms.pv_trips": "Отключений",
  "norms.pv_stops": "Остановок",
  "norms.pv_band": "Вне коридора, % минут под нагрузкой",
  "norms.pv_freq": "Вне нормы, минут под нагрузкой",
  "norms.pv_sharp": "Резких секунд",
  "norms.pv_prolonged": "Затяжных выходов",
  "norms.v_band_desc": "Линейное напряжение под нагрузкой должно быть в коридоре. Минуты, когда хоть одна фаза вышла из него, отмечаются в телеметрии, «Коридоре», «Всплесках», разборах и PDF.",
  "norms.v_dip_desc": "Линейное напряжение ниже порога под нагрузкой дольше 2 с. Провалы, между которыми меньше 2 минут, считаются одним.",
  "norms.trip_s_desc": "Если нагрузка упала до нуля быстрее порога — это отключение (сработал выключатель), медленнее — плановая остановка (закрывается направляющий аппарат).",
  "norms.f_band_desc": "Частота под нагрузкой; выходы за границы считаются в разделе «Отклонения» PDF-отчёта.",
  "norms.sharp_kv_desc": "Скачок линейного напряжения между соседними секундами, начиная с которого секунда считается резкой (раздел «Всплески»).",
  "norms.prolonged_s_desc": "Сколько секунд подряд напряжение (фаза ST) должно быть вне коридора, чтобы выход считался затяжным (раздел «Всплески»).",
  "norms.v_band_std": "это 20 кВ ± 5 %.",
  "norms.v_dip_std": "это 90 % номинала — так провал определяет ГОСТ 32144.",
  "system.at": "Состояние на {t}, время станции",
  "system.refresh": "Обновить",
  "system.services": "Сервисы",
  "system.svc_bot": "Бот @{bot}",
  "system.svc_api": "Приложение (API)",
  "system.svc_db": "База данных",
  "system.svc_web": "Сайт и HTTPS",
  "system.running": "работает",
  "system.down": "не работает",
  "system.since": "с {t}",
  "system.cert": "сертификат до {d}, продлевается сам",
  "system.restart_hint": "Время станции. Если база и сайт перезапустились ночью вместе — это автоматическое обновление безопасности сервера, не сбой.",
  "system.server": "Сервер",
  "system.disk": "Диск",
  "system.mem": "Память",
  "system.load": "Нагрузка процессора",
  "system.cores": "ядер: {n}",
  "system.uptime": "Без перезагрузки",
  "system.uptime_v": "{d} дн {h} ч",
  "system.of": "{a} из {b}",
  "system.db": "База данных · {size}",
  "system.g_v2_sec": "Телеметрия G1/G2, посекундно",
  "system.g_v2_min": "Телеметрия G1/G2, поминутно",
  "system.g_old": "Старые таблицы SCADA",
  "system.g_old_sub": "уже перенесены в G1, приложение их не читает",
  "system.g_pa": "Счётчик (Power Analyzer)",
  "system.g_other": "Алармы, события, пользователи, отчёты",
  "system.rows": "строк: ≈{n}",
  "system.rows_m": "строк: ≈{n} млн",
  "system.last_import": "Последний файл — {f}, данные по {to}.",
  "system.analyzed": "Статистика запросов обновлена {t}.",
  "system.backups": "Бэкапы",
  "system.no_backup": "Бэкапов нет",
  "system.timer_off": "Ночной бэкап выключен",
  "system.last_failed": "Последний бэкап не удался — подробности в журнале сервера",
  "system.last_ok": "Последний удачный — {t}, {size}",
  "system.k_db": "База целиком",
  "system.k_full_set": "Полный набор: база, код, настройки",
  "system.k_v2_tables_step": "Таблицы G1/G2 перед шагом 2",
  "system.k_v2_tables_import": "Таблицы G1/G2 перед загрузкой файла",
  "system.k_v1_tables": "Старые таблицы SCADA перед удалением",
  "system.k_other": "Другой дамп",
  "system.nightly": "Бэкап каждую ночь",
  "system.nightly_on": "в 03:00 по станции, хранится 14 дней · следующий {t}",
  "system.nightly_off": "выключен — включите, чтобы база сохранялась каждую ночь",
  "system.free": "свободно {v}",
  "system.backup_now": "Сделать бэкап сейчас",
  "system.backup_running": "Делаю бэкап… около минуты",
  "system.backup_done": "Бэкап готов: {size}",
  "system.backup_failed": "Бэкап не удался — подробности в журнале сервера",
  "system.reports": "Отчёты и события",
  "system.pdf": "PDF-отчёты",
  "system.pdf_sub": "сформировано: {n} · файлы хранятся {d} дн.",
  "system.events": "События",
  "system.events_sub": "отключения, остановки, пуски, провалы · пересчитаны {t}",
  "system.rebuild": "Пересчитать события",
  "system.rebuilt": "Пересчитано событий: {n}",
  "u.mb": "МБ",
  "u.gb": "ГБ",
  // ---------- 03.10.2026: reactive energy, chart sets, PDF row step and events ----------
  "auto.kpi_react": "Реактивная энергия",
  "auto.react_out": "выдано в сеть · Q > 0",
  "auto.react_in": "потреблено · Q < 0",
  "auto.react_hint": "Q > 0 — генератор выдаёт реактивную мощность в сеть, Q < 0 — потребляет из сети.",
  "auto.kvarh": "квар·ч",
  "auto.mvarh": "Мвар·ч",
  "home.react": "Реактив: выдано {out} · потреблено {inn} {u}",
  "charts.set": "Набор",
  "charts.set_one": "Один показатель",
  "charts.set_bearings": "Подшипники",
  "charts.set_oil": "Маслостанция",
  "charts.set_windings": "Обмотки",
  "charts.set_hydraulics": "Гидросистема",
  "charts.set_hint": "Серым — генератор стоял. Температуры и давления масла показаны и во время простоя.",
  "charts.set_under_load": "Под нагрузкой",
  "report.step": "Шаг строк в таблицах",
  "report.step_auto": "Авто",
  "report.step_hint": "Авто — как раньше: не больше 120 строк. Любой шаг можно, если строк не больше 3 600 (посекундно — до 1 часа).",
  "report.step_off": "Бледные — больше 3 600 строк: сузьте период. Посекундно за длинный период — Excel в «Отчётах» (у админа).",
  "report.rows_n": "{n} строк",
  "report.many": "Много страниц. Без частей 2–3 будет ≈ {n} стр.",
  "report.events": "Пуски и аварии",
  "report.ev_counts": "за период: аварийных отключений — {trip}, остановок — {stop}, пусков — {start}, провалов — {dip}",
  "report.ev_none": "за период событий нет",
  "report.i6": "События: пуски, аварийные отключения, остановки, провалы — с алармами журнала рядом",
  "report.making_big": "Собираю большой PDF… до 2–3 минут",
  "period.step_10s": "по 10 секунд",
  // ---------- 03.10.2026, step 2: uploads with a preview ----------
  "up.title": "Загрузить данные",
  "up.hint": "Отчёт станции G1/G2 (.csv, .gz), файл счётчика (.xlsx), журнал алармов (.csv) или архив .zip с такими файлами. Сначала покажу, что в нём и что уже есть в базе, — записывается только по кнопке.",
  "up.reading": "Читаю файл… большой архив — до минуты",
  "up.items": "Что в файле",
  "up.kind_nounit": "G1 или G2?",
  "up.kind_meter": "Счётчик",
  "up.kind_alarms": "Журнал алармов",
  "up.kind_unknown": "не распознан",
  "up.rows": "{n} строк",
  "up.alarm_rows": "{n} записей",
  "up.new": "новое: {n}",
  "up.in_db": "уже в базе: {n}",
  "up.clock_moved": "время файла (выгрузка через «;») переведено во время станции: {shift}",
  "up.clock_as_is": "время файла уже по станции — без сдвига",
  "up.clock_check": "по журналу в базе: со сдвигом совпало {a}, без сдвига — {b}",
  "up.clock_by_journal": "как у журнала алармов из этой загрузки",
  "up.pick_unit": "Какой генератор?",
  "up.more_days": "и ещё {n} дн.",
  "up.legend_new": "новое",
  "up.legend_part": "частично в базе",
  "up.legend_db": "уже в базе",
  "up.legend_none": "нет в файле",
  "up.how": "Как загрузить",
  "up.mode_missing": "Только недостающее",
  "up.mode_missing_sub": "то, что уже в базе, не трогаю",
  "up.mode_replace": "Заменить за период",
  "up.mode_replace_sub": "в пределах файла старые данные за период удаляются и берутся из файла",
  "up.range": "Период загрузки — по умолчанию весь файл, можно сузить до секунды",
  "up.need_unit": "Для файлов без G1/G2 в имени выберите генератор — иначе они будут пропущены.",
  "up.nothing": "Всё из файла уже есть в базе — загружать нечего.",
  "up.go": "Загрузить",
  "up.go_new": "Загрузить новое: {n} строк",
  "up.running": "Загружаю… экран можно закрыть — загрузка идёт на сервере",
  "up.done": "Готово",
  "up.again": "Загрузить ещё файл",
  "up.st_running": "загружается",
  "up.st_done": "загружено {n} строк",
  "up.st_events": "событий найдено: {n}",
  "up.st_nothing": "всё уже было в базе",
  "up.st_error": "ошибка",
  "up.st_skip": "пропущен",
  "up.st_ready": "в очереди",
  "up.alarms_title": "Журнал алармов станции",
  "up.alarms_cover": "В базе {n} записей: {from} → {to}",
  "up.src_alarms": "Журнал алармов",
  "up.src_hint": "Выбор задаёт генератор для отчётов без G1/G2 в имени и историю ниже; в архиве можно смешивать любые файлы.",
  // ---------- 03.10.2026, step 3: the bot takes files ----------
  "users.right_upload": "Загрузка данных через бота",
};
